/**
 * Jotai atoms for usage feature state management
 * Manages year and month filter state, and pagination for credit transactions
 */

import { atom } from 'jotai';

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();

// Pagination atoms
export const currentPageAtom = atom<number>(1);
export const itemsPerPageAtom = atom<number>(50);

// Year and month filter atoms with pagination reset
const _selectedYearAtom = atom<string>(String(currentYear));
const _selectedMonthAtom = atom<string>(String(currentMonth));

// Action atoms that reset pagination when filters change
export const selectedYearAtom = atom(
	(get) => get(_selectedYearAtom),
	(get, set, newValue: string) => {
		set(_selectedYearAtom, newValue);
		set(currentPageAtom, 1); // Reset to first page when year changes
	},
);

export const selectedMonthAtom = atom(
	(get) => get(_selectedMonthAtom),
	(get, set, newValue: string) => {
		set(_selectedMonthAtom, newValue);
		set(currentPageAtom, 1); // Reset to first page when month changes
	},
);

// Derived atom for API parameters
export const creditsQueryParamsAtom = atom((get) => {
	const selectedYear = get(_selectedYearAtom);
	const selectedMonth = get(_selectedMonthAtom);

	const params: Record<string, string> = {
		year: selectedYear,
		month: selectedMonth,
	};

	return params;
});
